"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeQwilrYourOwn = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./MakeQwilrYourOwn.css"));
var LogoUploader_1 = require("Onboarding/CensusCollector/MakeQwilrYourOwn/LogoUploader");
var DomainUrlInput_1 = require("Onboarding/CensusCollector/MakeQwilrYourOwn/DomainUrlInput");
var BrandColourSetup_1 = require("Onboarding/CensusCollector/MakeQwilrYourOwn/BrandColourSetup");
var SubdomainInput_1 = require("Onboarding/CensusCollector/MakeQwilrYourOwn/SubdomainInput");
var mobx_react_1 = require("mobx-react");
var BrandFetchDetails_1 = require("@CommonFrontendBackend/Account/Brand/BrandFetchDetails");
var Transitions_1 = require("Onboarding/CensusCollector/Common/Transitions");
var inversify_react_1 = require("inversify-react");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var PromptTypes_1 = require("Prompt/PromptTypes");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var Separator = function () {
    return react_1.default.createElement("hr", { className: styles.separator });
};
var UpdateBrandDataErrorType;
(function (UpdateBrandDataErrorType) {
    UpdateBrandDataErrorType["BRAND_COLORS"] = "BRAND_COLORS";
    UpdateBrandDataErrorType["SUBDOMAIN"] = "SUBDOMAIN";
    UpdateBrandDataErrorType["LOGOS"] = "LOGOS";
})(UpdateBrandDataErrorType || (UpdateBrandDataErrorType = {}));
exports.MakeQwilrYourOwn = (0, mobx_react_1.observer)(function (_a) {
    var onComplete = _a.onComplete;
    var _b = __read((0, react_1.useState)(500), 2), baseTransitionTimeout = _b[0], setBaseTransitionTimeout = _b[1];
    var _c = __read((0, react_1.useState)(0), 2), fetchCount = _c[0], setFetchCount = _c[1];
    var dataStore = (0, inversify_react_1.useInjection)("censusCollectorStore");
    var onboardingTelemetryService = (0, inversify_react_1.useInjection)("onboardingTelemetryService");
    var apiService = (0, inversify_react_1.useInjection)("apiService");
    var user = (0, inversify_react_1.useInjection)("user");
    var modal = (0, inversify_react_1.useInjection)("modal");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var accountService = (0, inversify_react_1.useInjection)("accountService");
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var promptHistory = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore
        .inlinePromptsHistoryStore;
    var subdomainInputRef = (0, react_1.useRef)();
    var onSkipHandler = function () {
        onboardingTelemetryService
            .onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.MakeQwilrYourOwn, {
            brandConfigured: false,
            brandPrefilled: dataStore.shouldFetchBrandDetails(),
        })
            .catch(function () { return ({}); });
        onComplete();
        dataStore.shouldShowTailoredPages = false;
    };
    var skip = function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            if (!dataStore.isBrandDetailsEmpty) {
                modal.showConfirmModal({
                    title: "Are you sure?",
                    explainer: "It looks like you have added some brand data. They will not be saved if you continue.",
                    confirmLabel: "Continue",
                    cancelLabel: "Go back",
                    confirming: function () { return __awaiter(void 0, void 0, Promise, function () {
                        return __generator(this, function (_a) {
                            onSkipHandler();
                            return [2];
                        });
                    }); },
                });
            }
            else {
                onSkipHandler();
            }
            return [2];
        });
    }); };
    var submit = function () { return __awaiter(void 0, void 0, Promise, function () {
        var promises, updateError, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = [];
                    updateError = undefined;
                    if (dataStore.colors.length > 0) {
                        brandStore.colors = dataStore.colors;
                        promises.push(brandStore.saveBrandSettingUpdate((0, GetFullName_1.default)(user)).catch(function (e) {
                            updateError = UpdateBrandDataErrorType.BRAND_COLORS;
                            throw e;
                        }));
                    }
                    if (!!dataStore.qwilrSubdomain) {
                        promises.push(accountService.setSubdomain(dataStore.qwilrSubdomain, event_tracker_types_1.EventOrigin.QwilrOnboarding).catch(function (e) {
                            updateError = UpdateBrandDataErrorType.SUBDOMAIN;
                            throw e;
                        }));
                    }
                    if (dataStore.logoUrls.length > 0) {
                        promises.push(apiService.uploadLogos(dataStore.logoUrls).catch(function (e) {
                            updateError = UpdateBrandDataErrorType.LOGOS;
                            throw e;
                        }));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, Promise.all(promises)];
                case 2:
                    _a.sent();
                    promptHistory.setActionCompleted(PromptTypes_1.PromptId.PagesDashboardOnboardingBanner, UseHistoryTypes_1.PagesOnboardingBannerAction.BrandSetup);
                    dataStore.shouldShowTailoredPages = true;
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    if (updateError === UpdateBrandDataErrorType.BRAND_COLORS) {
                        notifyUser.error("Unable to set your brand colors. Please try again!");
                    }
                    else if (updateError === UpdateBrandDataErrorType.SUBDOMAIN) {
                        notifyUser.error("Unable to set your Qwilr subdomain. Please try again!");
                    }
                    else if (updateError === UpdateBrandDataErrorType.LOGOS) {
                        notifyUser.error("Unable to save your logo. Please try another file!");
                    }
                    else {
                        notifyUser.error("Unable to set your brand data. Please try again later!");
                    }
                    throw e_1;
                case 4:
                    onboardingTelemetryService.brandConfigured().catch(function () { return ({}); });
                    onboardingTelemetryService
                        .onboardingStepCompleted(event_tracker_types_1.OnboardingStepName.MakeQwilrYourOwn, {
                        brandConfigured: true,
                        brandPrefilled: dataStore.shouldFetchBrandDetails(),
                    })
                        .catch(function () { return ({}); });
                    onComplete();
                    return [2];
            }
        });
    }); };
    var manuallyFetch = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var urlNoProtocol, brandDetails;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    urlNoProtocol = url.replace(/^https?\:\/\//i, "");
                    return [4, apiService.fetchBrandDetails(urlNoProtocol)];
                case 1:
                    brandDetails = _b.sent();
                    setFetchCount(fetchCount + 1);
                    dataStore.updateBrandDetails(brandDetails, url);
                    (_a = subdomainInputRef.current) === null || _a === void 0 ? void 0 : _a.updateSubdomain(dataStore.qwilrSubdomain);
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", className: styles.heading },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center", strong: true }, "Make Qwilr yours"),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "l", align: "center" }, "Enter your brand details: add your colors, logos and more"))),
        react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 100 },
            dataStore.brandDetailsState === BrandFetchDetails_1.BrandFetchState.AutoFetched && (react_1.default.createElement("div", { className: styles.informationSection({ status: "success", style: "relaxed" }) },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.informationSectionText({ status: "success" }) },
                    react_1.default.createElement(icons_1.Spark, { size: icons_1.IconSize.Small, className: styles.informationSectionIcon }), " We found brand details for the domain \"".concat(dataStore.companyDomain, "\". You can make changes below or choose a "),
                    react_1.default.createElement(kaleidoscope_1.Link, { className: styles.tryItAgainLink, onClick: function () {
                            setBaseTransitionTimeout(300);
                            dataStore.resetBrandDetails();
                        } }, "different domain.")))),
            [BrandFetchDetails_1.BrandFetchState.AutoFetchFailed, BrandFetchDetails_1.BrandFetchState.ManualFetchFailed].includes(dataStore.brandDetailsState) && (react_1.default.createElement("div", { className: styles.informationSection({ status: "failed", style: "compact" }) },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.informationSectionText({ status: "failed" }) },
                    react_1.default.createElement(icons_1.InformationCircle, { size: icons_1.IconSize.Small, className: styles.informationSectionIcon }), " We can\u2019t seem to find brand details for your domain. Try something else."))),
            dataStore.brandDetailsState === BrandFetchDetails_1.BrandFetchState.ManuallyFetched && (react_1.default.createElement("div", { className: styles.informationSection({ status: "success", style: "compact" }) },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.informationSectionText({ status: "success" }) },
                    react_1.default.createElement(icons_1.Spark, { size: icons_1.IconSize.Small, className: styles.informationSectionIcon }), " We found brand details for the domain \"".concat(dataStore.companyDomain, "\". You can make changes below."))))),
        dataStore.brandDetailsState !== BrandFetchDetails_1.BrandFetchState.AutoFetched && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Transitions_1.FadeInTransition, { key: "domain-url-input", timeout: baseTransitionTimeout + 200, className: styles.urlInputContainer },
                react_1.default.createElement("div", { className: styles.urlInput },
                    react_1.default.createElement(DomainUrlInput_1.DomainUrlInput, { onSubmit: manuallyFetch, dataStore: dataStore }))),
            react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 300, key: "".concat(dataStore.brandDetailsState, ":separator:").concat(fetchCount) },
                react_1.default.createElement(Separator, null)))),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.brandSetup, direction: "horizontal", justify: "center", gap: "xl", wrap: true },
            react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 400, key: "".concat(dataStore.brandDetailsState, ":logo-uploader:").concat(fetchCount), className: styles.logoUploader },
                react_1.default.createElement(LogoUploader_1.LogoUploader, { dataStore: dataStore })),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.brandColorsAndSubdomain, direction: "vertical", gap: "m" },
                react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 500, key: "".concat(dataStore.brandDetailsState, ":brand-colour:").concat(fetchCount) },
                    react_1.default.createElement("div", { className: styles.brandColors },
                        react_1.default.createElement(BrandColourSetup_1.BrandColourSetup, { dataStore: dataStore }))),
                react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 600, key: "".concat(dataStore.brandDetailsState, ":subdomain:").concat(fetchCount) },
                    react_1.default.createElement(SubdomainInput_1.SubdomainInput, { dataStore: dataStore, apiService: apiService, ref: subdomainInputRef })))),
        react_1.default.createElement(Transitions_1.FadeInTransition, { timeout: baseTransitionTimeout + 700, key: "".concat(dataStore.brandDetailsState, ":buttons:").concat(fetchCount) },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "m", align: "center", className: styles.buttonGroup({
                    style: dataStore.brandDetailsState === BrandFetchDetails_1.BrandFetchState.AutoFetched ? "relaxed" : "compact",
                }) },
                react_1.default.createElement(kaleidoscope_1.Tooltip, { show: dataStore.brandDetailsError ? undefined : false, content: dataStore.brandDetailsError, size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true },
                    react_1.default.createElement(kaleidoscope_1.Button, { className: styles.submitButton({ status: dataStore.brandDetailsError ? "disabled" : "enabled" }), type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Large, onClick: function (event) {
                            event.preventDefault();
                            if (!!dataStore.brandDetailsError) {
                                return;
                            }
                            return submit();
                        } }, "Continue")),
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: function (event) {
                        event.preventDefault();
                        skip();
                    } },
                    react_1.default.createElement("span", null, "Do it later"))))));
});
